<template>
  <div class="home">
    <ul class="link-list">
      <li v-for="(item, index) in pages" :key="index">
        <router-link :to="item.link">{{ item.name }}</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "Home",
  data() {
    return {
      pages: [
        { name: "登录", link: "/login" },
        { name: "关于我们", link: "/about_us" },
        { name: "隐私政策", link: "/private" },
        { name: "用户协议", link: "/protocol" },
        { name: "第三方SDK目录", link: "/sdk_list" },
        { name: "积分规则", link: "/score_rule" },
        { name: "邀请", link: "/invitation?contentType=invite&inviteCode=7UVT52&appName=%E6%B9%96%E5%8C%97%E6%97%A5%E6%8A%A5" },
      ],
    };
  },
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  .link-list {
    li {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 16px;
      line-height: 24px;
      text-align: center;
      font-size: 14px;
      ::after {
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 16px;
        bottom: 0;
        left: 16px;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
    }
  }
}
</style>